import { IsString } from "class-validator";

export enum OrderStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    FULFILLED = "FULFILLED",
    CANCELED = "CANCELED"
}

export class ReplenishmentOrderVm {
    @IsString()
    id: string;

    @IsString()
    warehouseId: string;

    @IsString()
    locationId: string;

    @IsString()
    productId: string;

    @IsString()
    productName: string;

    @IsString()
    productSku: string;

    @IsString()
    quantity: number;

    @IsString()
    status: OrderStatus;
}
